<template>
  <div>
    <!-- Sidebar de filtros -->
    <b-sidebar
      :visible="value"
      :class="`${sidebarClass} b-sidebar-light`"
      right
      shadow
      backdrop
      width="430px"
      no-header
      @change="$emit('input', $event)"
    >
      <div class="sidebar-custom-header d-flex justify-content-between align-items-center px-1 py-1 border-bottom">
        <h5 class="font-weight-bolder m-0">
          {{ title }}
        </h5>
        <button
          type="button"
          class="close"
          @click="$emit('input', false)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="px-1 py-1">
        <!-- Slot para los filtros personalizados -->
        <slot name="filters" />

        <!-- Botones de Limpiar y Filtrar -->
        <b-row class="mt-2">
          <b-col cols="6">
            <b-button
              variant="outline-primary"
              block
              @click="handleClearFilters"
            >
              Limpiar
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button
              variant="primary"
              block
              @click="handleApplyFilters"
            >
              Filtrar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>

    <!-- Resumen de filtros activos -->
    <div
      v-if="hasActiveFilters && activeFilters && activeFilters.length"
      class="mb-2 p-2 bg-light border rounded"
    >
      <div class="d-flex justify-content-between align-items-start">
        <small class="text-muted font-weight-bolder">{{ activeFiltersLabel }}</small>
        <b-button
          size="sm"
          variant="outline-primary"
          @click="handleClearFilters"
        >
          Limpiar filtros
        </b-button>
      </div>
      <div class="d-flex flex-wrap" style="gap: 0.75rem;">
        <!-- Renderizar badges de filtros activos -->
        <div
          v-for="(filter, index) in activeFilters"
          :key="index"
        >
          <b-badge variant="primary" class="d-flex align-items-center px-50 py-50">
            <feather-icon :icon="filter.icon" size="14" class="mr-1" />
            {{ filter.label }}: {{ filter.value }}
            <b-link
              href="#"
              class="text-white ml-1 font-weight-bolder font-medium-2"
              @click.prevent="removeFilter(index)"
            >
              ×
            </b-link>
          </b-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BSidebar, BBadge, BLink,
} from 'bootstrap-vue'

export default {
  name: 'FilterSidebar',
  components: {
    BRow,
    BCol,
    BButton,
    BSidebar,
    BBadge,
    BLink,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Filtros',
    },
    sidebarClass: {
      type: String,
      default: '',
    },
    hasActiveFilters: {
      type: Boolean,
      required: true,
    },
    activeFiltersLabel: {
      type: String,
      default: 'Filtros activos:',
    },
    activeFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
  methods: {
    handleApplyFilters() {
      this.$emit('input', false)
      this.$emit('apply-filters')
    },
    handleClearFilters() {
      this.$emit('clear-filters')
    },
    removeFilter(index) {
      this.$emit('remove-filter', index)
    },
  },
}
</script>

<style lang="scss" scoped>
// Los estilos globales se heredan de las clases globales
// b-sidebar-light y sidebar-custom-header
</style>
